import { C } from "./const";
import SectionBadge from "./IntroSectionBadge";
import SectionTitle from "./IntroSectionTitle";

const TESTIMONIALS = [
    {
        name: "علی محمدی",
        role: "مشتری بیمه خودرو",
        text: "در زمان تصادف، کارشناسان به سرعت کمک کردند و خسارت در کمتر از یک هفته پرداخت شد. واقعاً ممنونم.",
        stars: 5,
    },
    {
        name: "فاطمه احمدی",
        role: "مشتری بیمه درمان",
        text: "مشاوره رایگان و حرفه‌ای دریافت کردم. بهترین پلن بیمه درمان را با توجه به بودجه‌ام انتخاب کردم.",
        stars: 5,
    },
    {
        name: "محمد رضایی",
        role: "مشتری بیمه عمر",
        text: "خدمات بسیار عالی و پاسخگویی سریع. از همکاری با این نمایندگی بسیار راضی هستم.",
        stars: 5,
    },
];

const IntroTestimonials = () => {

    return (

        <section id="testimonials" style={{ background: C.neutralLight, padding: "80px 24px" }}>
            <div style={{ maxWidth: 1200, margin: "0 auto" }}>
                <div style={{ textAlign: "center", marginBottom: 52 }}>
                    <SectionBadge text="نظرات مشتریان" />
                    <SectionTitle center>مشتریان ما چه می‌گویند؟</SectionTitle>
                    <p style={{ color: C.gray, fontSize: 16, maxWidth: 520, margin: "0 auto", lineHeight: 1.8 }}>
                        رضایت مشتریان ما بهترین سند کیفیت خدمات ماست
                    </p>
                </div>

                <div
                    className="grid-3"
                    style={{
                        display: "grid",
                        gridTemplateColumns: "repeat(3,1fr)",
                        gap: 26,
                    }}
                >
                    {TESTIMONIALS.map((t) => (
                        <div
                            key={t.name}
                            className="hov-lift"
                            style={{
                                background: C.white,
                                borderRadius: 18,
                                padding: 30,
                                boxShadow: "0 4px 20px rgba(0,86,179,.07)",
                                border: `1px solid ${C.border}`,
                            }}
                        >
                            {/* Stars */}
                            <div style={{ display: "flex", gap: 3, marginBottom: 16 }}>
                                {Array.from({ length: t.stars }).map((_, i) => (
                                    <span key={i} style={{ color: C.accent, fontSize: 18 }}>★</span>
                                ))}
                            </div>

                            <p style={{ color: C.gray, fontSize: 14, lineHeight: 1.85, marginBottom: 22, fontStyle: "italic" }}>
                                «{t.text}»
                            </p>

                            <div style={{ display: "flex", alignItems: "center", gap: 12 }}>
                                <div
                                    style={{
                                        width: 44,
                                        height: 44,
                                        borderRadius: "50%",
                                        background: `linear-gradient(135deg, ${C.primary}, ${C.primaryDark})`,
                                        display: "flex",
                                        alignItems: "center",
                                        justifyContent: "center",
                                        color: C.white,
                                        fontWeight: 800,
                                        fontSize: 16,
                                        flexShrink: 0,
                                    }}
                                >
                                    {t.name[0]}
                                </div>
                                <div>
                                    <div style={{ fontWeight: 700, color: C.primaryDark, fontSize: 14 }}>{t.name}</div>
                                    <div style={{ color: C.grayLight, fontSize: 12 }}>{t.role}</div>
                                </div>
                            </div>
                        </div>
                    ))}
                </div>
            </div>
        </section>

    );
}

export default IntroTestimonials;